import React from "reactn";
import axios from "axios";
import { toast } from "react-toastify";

class StripeExpress extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      stripe: null
    };
    this.setGlobal({
      pathway: [...this.global.pathway.slice(0, 1), "Payment Settings"]
    });
  }

  async componentDidMount() {
    const params = this.props.location.query;
    const ep = `${process.env.REACT_APP_API}/stripe`;

    // If we just returned from onboarding, refresh account info
    if (params && (params.onboarding || params.refresh)) {
      this.setGlobal({ loading: true });
      try {
        const res = await axios.get(ep);
        if (res.data.success) this.setState({ stripe: res.data.data });
      } catch (ex) {
        console.error(ex);
      } finally {
        this.setGlobal({ loading: false });
      }
      return;
    }

    // Normal load: fetch current connection if any
    try {
      this.setGlobal({ loading: true });
      const res = await axios.get(ep);
      if (res.data.success) {
        this.setState({
          stripe: res.data.data
        });
      }
      this.setGlobal({ loading: false, lastAPICall: res });
    } catch (ex) {
      console.error(ex);
      this.setGlobal({ loading: false, lastAPICall: null });
    }
  }

  // Not used anymore
  generateState = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  };

  render() {
    return (
      <div className="container-fluid">
        <div className="cont">
          <div className="row">
            <div className="col-md-6">
              <h1>Stripe Connect</h1>
            </div>
          </div>
        </div>
        <div className="cont boxes-row boxes-row-fluid mb-5">
          <div className="box" style={{ maxWidth: "none" }}>
            <div className="bgofbox">
              <div className="header">
                <h2>Payment Settings</h2>
              </div>
              <div className="formbody">
                {this.state.stripe ? null : (
                  <div className="row mt-2">
                    <div
                      className="col-12 text-center"
                      style={{ fontSize: "10pt" }}
                    >
                      To make paying you as easy and seamless as possible, we've
                      partnered with Stripe to ensure the best possible
                      experience when receiving your payouts.
                      <br />
                      <br />
                      <button
                        onClick={async () => {
                          this.setGlobal({ loading: true });
                          try {
                            const res = await axios.post(`${process.env.REACT_APP_API}/stripe/onboard`);
                            if (res.data.success) window.location.href = res.data.data.accountLinkUrl;
                          } catch (ex) {
                            console.error(ex);
                            toast.error("Failed to initiate Stripe onboarding.");
                          } finally {
                            this.setGlobal({ loading: false });
                          }
                        }}
                        className="parent__handbook_link"
                        style={{
                          width: "fit-content",
                          paddingTop: 4,
                          paddingBottom: 4,
                          paddingLeft: 14,
                          paddingRight: 14,
                          margin: "auto auto"
                        }}
                      >
                        Connect With Stripe
                      </button>
                    </div>
                  </div>
                )}

                {!this.state.stripe ? null : (
                  <>
                    <div className="row mt-2" style={{ fontSize: "10pt" }}>
                      <div className="col-12">
                        You're already connected with the following account:
                      </div>
                    </div>
                    <div className="row mt-2" style={{ fontSize: "10pt" }}>
                      <div className="col-3">
                        <b>Bank:</b>
                      </div>
                      <div className="col-9">
                        {
                          this.state.stripe.stripeCon.external_accounts.data[0]
                            .bank_name
                        }
                      </div>
                      <div className="col-3">
                        <b>Account Number:</b>
                      </div>
                      <div className="col-9">
                        {
                          this.state.stripe.stripeCon.external_accounts.data[0]
                            .last4
                        }
                      </div>
                    </div>
                    <div className="row mt-2" style={{ fontSize: "10pt" }}>
                      <div className="col-12">
                        If you'd like to make changes to your payout settings
                        please use the link below:
                        <br />
                        <br />
                        <a
                          href={this.state.stripe.stripeLogin.url}
                          className="parent__handbook_link"
                          style={{
                            width: "fit-content",
                            paddingTop: 4,
                            paddingBottom: 4,
                            paddingLeft: 14,
                            paddingRight: 14,
                            margin: "auto auto"
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Update Payout Settings
                        </a>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StripeExpress;